
    import Navigator from "@/components/navigator/Navigator.vue";
    import Breadcrumb from "@/components/breadcrumb/Breadcrumb.vue";
    
    export default {
        name: "HeaderLayout",
        props: {
            title: String,
            subtitle: String,
            backgroundImage: String,
            displayNavigator: {
                type: Boolean,
                default: true,
            },
            displayBreadcrumb: {
                type: Boolean,
                default: true,
            },
        },
        components: {
            Navigator,
            Breadcrumb,
        },
        methods: {
            setBackground(): void {
                if ((this as any).backgroundImage != null) {
                    (this as any).$refs.titleSection.style.backgroundImage
                        = "url('" + (this as any).backgroundImage + "')";
                    (this as any).$refs.titleSection.style.textShadow
                        = "var(--outline-text-shadow)";
                }
            },
        },
        mounted() {
            (this as any).setBackground();
        },
    };
